import * as React from 'react';
import { Collapse } from 'antd';
import { CATEGORY_FILTER, DATE_FILTER } from '@bakbak/common';
import { OptionsComponent } from './OptionsComponent';
import { withHeaderContext, HeaderContext } from '../../context/HeaderContext';

const Panel = Collapse.Panel;

interface Props {
  headerContext: HeaderContext;
}

export class FilterC extends React.PureComponent<Props> {
  updateCategoryOptions = (options: string[]) => {
    this.props.headerContext.updateCategoryFilter([...options]);
  }
  updateDateOptions = (options: string[]) => {
    this.props.headerContext.updateDateFilter([...options]);
  }
  renderCategoryFilter = () => {
    return (
      <Panel header={<div style={{ fontSize: 12, fontWeight: 600 }}>Category</div>}
        key={"category"}
        style={styles.panelStyle}
      >
        <OptionsComponent
          options={CATEGORY_FILTER}
          selectedOptions={this.props.headerContext.categoryFilter}
          optionDesignType="tag"
          updateOptions={this.updateCategoryOptions}
          multiSelect={true}
        />
      </Panel>
    );
  }
  renderDateFilter = () => {
    return (
      <Panel header={<div style={{ fontSize: 12, fontWeight: 600 }}>Date</div>}
        key={"date"}
        style={styles.panelStyle}
      >
        <OptionsComponent
          options={DATE_FILTER}
          selectedOptions={this.props.headerContext.dateFilter}
          optionDesignType="tag"
          updateOptions={this.updateDateOptions}
          multiSelect={false}
        />
      </Panel>
    );
  }
  render() {
    return (
      <Collapse bordered={false} defaultActiveKey={["category", "date"]}>
        {this.renderCategoryFilter()}
        {this.renderDateFilter()}
      </Collapse>
    );
  }
}

export const FilterComponent = withHeaderContext(FilterC);

const styles = {
  panelStyle: {
    background: '#fff',
    borderRadius: 0,
    overflow: 'hidden',
  }
};



// WEBPACK FOOTER //
// ./src/modules/layout/FilterComponent.tsx